import styled from "styled-components";
export const PrivateYachtBookingWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
